module.exports = __webpack_public_path__ + "static/media/Vector.f58e4f7f.svg";